// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"8b0c7a7c","368":"8c1c4dab","527":"32be7269","594":"9d2aa103","701":"a8d39c82"}[chunkId] + ".chunk.css";
};